import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";
import { Provider } from "react-redux";
import { createBrowserHistory } from "history";
import "bootstrap/dist/css/bootstrap.css";
import { injectStore } from "./api/Request";
import { ErrorBoundary } from "react-error-boundary";
import ReactErrorBoundary from "./components/reactErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));

export const history = createBrowserHistory();

injectStore(store);

root.render(
  <Provider store={store}>
    <ErrorBoundary FallbackComponent={ReactErrorBoundary}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ErrorBoundary>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
